module.exports = "./img/1ade0704e1e7fd2924270cd2deb9cdb4.jpg";